import { jsx as _jsx } from "react/jsx-runtime";
// import hooks
import { useState, useEffect } from "react";
import Image from "../../../components/atoms/Image/index.js";
export const ImageGuardAtomComponent = ({ src, ...props }) => {
    const [show, setShow] = useState(true);
    useEffect(() => {
        setShow(true);
    }, [src]);
    if (!show)
        return null;
    return (_jsx(Image, { "data-testid": "ImageGuard", onError: () => {
            setShow(false);
        }, src: src, ...props }));
};
export default ImageGuardAtomComponent;
